(() => {
  document.querySelectorAll('[data-lvl-ingredients]').forEach((root) => {
    const track = root.querySelector('[data-lvl-ingredients-track]');
    const slides = Array.from(root.querySelectorAll('.lvl-ingredients__slide'));
    const previous = root.querySelector('[data-lvl-ingredients-prev]');
    const next = root.querySelector('[data-lvl-ingredients-next]');
    const dots = root.querySelector('[data-lvl-ingredients-dots]');
    if (!(track instanceof HTMLElement) || !slides.length || !dots) return;
    dots.parentElement?.removeAttribute('hidden');

    let step = 0;
    let pageCount = 1;
    let activePage = 0;
    let frame = 0;
    let resizeFrame = 0;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const measure = () => {
      const firstSlide = slides[0];
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      step = firstSlide.getBoundingClientRect().width + gap;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      pageCount = Math.max(1, Math.min(slides.length, Math.ceil(maxScroll / step) + 1));
    };

    const update = () => {
      frame = 0;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      activePage = maxScroll === 0 ? 0 : Math.min(pageCount - 1, Math.round(track.scrollLeft / step));
      dots.querySelectorAll('.lvl-ingredients__dot').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === activePage ? 'true' : 'false');
      });
      if (previous instanceof HTMLButtonElement) previous.disabled = activePage === 0;
      if (next instanceof HTMLButtonElement) next.disabled = activePage === pageCount - 1;
    };

    const goTo = (page) => {
      const target = Math.max(0, Math.min(page, pageCount - 1));
      track.scrollTo({
        left: Math.min(target * step, track.scrollWidth - track.clientWidth),
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    const build = () => {
      measure();
      dots.replaceChildren();
      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');
        dot.className = 'lvl-ingredients__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Go to ingredient slide ${index + 1}`);
        dot.addEventListener('click', () => goTo(index));
        dots.appendChild(dot);
      }
      update();
    };

    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }, { passive: true });

    if (previous instanceof HTMLButtonElement) {
      previous.addEventListener('click', () => goTo(activePage - 1));
    }
    if (next instanceof HTMLButtonElement) {
      next.addEventListener('click', () => goTo(activePage + 1));
    }

    window.addEventListener('resize', () => {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(build);
    }, { passive: true });

    build();
  });
})();
